import React, { useEffect, useState } from "react";
import { Card, Button, Space, Input, Form } from "antd";
import { DownloadOutlined, PlusCircleFilled } from "@ant-design/icons";
import { updateDoc, doc, collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";

import "./Notes.css";
import FormAction from "../FormAction";
import { toast } from "react-hot-toast";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import { SelectUser } from "../../../store/usersSlice";

const { TextArea } = Input;

function Notes({ notesForCollection, notesForCollectionId, companyName, notes, setNotes }) {
  // const [notes, setNotes] = useState([]);
  const [note, setNote] = useState("");
  const [textValue, setTextValue] = useState("");
  const [inputCardVisible, setInputCardVisibility] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);

  console.log("company name************", companyName);
  const userInfo = useSelector(SelectUser);
  console.log("userData", userInfo);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const collectionRef = collection(
          db,
          "companies",
          companyName,
          notesForCollection
        );
        const snapshot = await getDocs(collectionRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const filteredCollection = fetchedData.find(
          (item) => item.id == notesForCollectionId
        );
        console.log("filtered collection", filteredCollection);
        setNotes(
          filteredCollection?.notes?.length > 0 ? filteredCollection?.notes : []
        );
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchCollection();
  }, [notesForCollectionId]);

  const closeEditNote = () => {
    setEdit(false);
    setEditingItemId(null);
  };

  const cancelCreateNote = () => {
    setInputCardVisibility(false);
    setNote("");
  };

  const handleEdit = (itemId) => {
    setEditingItemId(itemId);
    setEdit(true);
  };

  const noteId = uuidv4();
  const addNote = () => {
    const newNote = {
      id: noteId,
      text: note,
      postedBy: userInfo?.firstName + " " + userInfo?.lastName,
      postedOn: dayjs().format("YYYY-MM-DD"),
    };
    setNotes([...notes, newNote]);
    setInputCardVisibility(false);
    setNote("");

    if (companyName && notes && notesForCollectionId) {
      try {
        const collectionRef = doc(
          db,
          "companies",
          companyName,
          notesForCollection,
          notesForCollectionId
        );
        const notesObj = {
          notes: [...notes, newNote],
        };
        updateDoc(collectionRef, notesObj);
        toast.success(`notes info updated successfully`);
      } catch (error) {
        console.error("Errr...........:", error);
      }
    }
  };

  const removeNote = (id) => {
    const updatedNotes = notes.filter((item) => item.id !== id);
    setNotes(updatedNotes);

    if (companyName && notes && notesForCollectionId) {
      try {
        const collectionRef = doc(
          db,
          "companies",
          companyName,
          notesForCollection,
          notesForCollectionId
        );
        const notesObj = {
          notes: updatedNotes,
        };
        updateDoc(collectionRef, notesObj);
        toast.success(`notes info updated successfully`);
      } catch (error) {
        console.error("Errr...........:", error);
      }
    }
  };

  const handleChange = (name) => {
    const updatedNotes = notes.map((item) => {
      if (item.id === editingItemId) {
        return { ...item, [name]: textValue };
      }
      return item;
    });
    setNotes(updatedNotes);
    setEdit(false);
    setEditingItemId(null);

    if (companyName && notes) {
      try {
        const collectionRef = doc(
          db,
          "companies",
          companyName,
          notesForCollection,
          notesForCollectionId
        );
        const notesObj = {
          notes: updatedNotes,
        };
        updateDoc(collectionRef, notesObj);
        toast.success(`notes info updated successfully`);
      } catch (error) {
        console.error("Errr...........:", error);
      }
    }
  };

  const handleAddNotes = () => {
    setInputCardVisibility(true);
    setNote("");
  };

  const mainHeaderButtons = (
    <Space wrap>
      <Button
        className="headerButtons"
        size="small"
        icon={<DownloadOutlined />}
      >
        Download Notes
      </Button>
      <Button
        className="headerButtons"
        size="small"
        icon={<PlusCircleFilled />}
        onClick={() => handleAddNotes()}
      >
        Add Notes
      </Button>
    </Space>
  );

  const notesHeaderButtons = (id) => {
    return (
      <>
        <Button
          className="notesHeaderButtons"
          type="link"
          onClick={() => {
            handleEdit(id);
          }}
        >
          Edit
        </Button>
        <Button
          className="notesHeaderButtons"
          type="link"
          onClick={() => {
            removeNote(id);
          }}
        >
          Delete
        </Button>
      </>
    );
  };

  return (
    <Card title="Notes" bordered={false} extra={mainHeaderButtons}>
      <Card
        style={{
          width: "100%",
          marginBottom: 10,
          display: inputCardVisible ? "block" : "none",
        }}
      >
        <TextArea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={4}
          style={{ marginBottom: 12, fontSize: "13px" }}
        />
        <FormAction save={() => addNote()} cancel={() => cancelCreateNote()} />
      </Card>
      <ul>
        {notes.map((item, index) => (
          <li key={index}>
            <Card
              className="notesCard"
              title={"Posted by - " + item.postedBy + " on " + item.postedOn}
              bordered={false}
              style={{ marginBottom: 12 }}
              extra={notesHeaderButtons(item.id)}
            >
              {editingItemId === item.id ? (
                <Form initialValues={{ [`note${index}`]: item.text }}>
                  <Form.Item name={`note${index}`}>
                    <TextArea
                      rows={4}
                      bordered={true}
                      style={{ marginBottom: 12, fontSize: "13px" }}
                      onChange={(e) => setTextValue(e.target.value)}
                    />
                  </Form.Item>
                  <FormAction
                    save={() => {
                      handleChange("text");
                    }}
                    cancel={() => {
                      closeEditNote(item.id);
                    }}
                  />
                </Form>
              ) : (
                <>
                  <p style={{ fontSize: "13px" }}>{item.text}</p>
                </>
              )}
            </Card>
          </li>
        ))}
      </ul>
    </Card>
  );
}

export default Notes;
